import store from '@/stores/'
import UNIQUE from '@/common/unique'

const defaultValue = {
  list: 'select list',
  item: 'select item'
}
const langValue = function (targetVal) {
  const obj = Object.assign({}, store.state.setting.lang.langValue)
  Object.keys(obj).forEach(function (x) {
    obj[x] = defaultValue[targetVal]
  })
  return obj
}
const defaultItem = function () {
  const objData = {
    label: langValue('item'),
    value: defaultValue.item,
    price: 0
  }
  return Object.assign({}, objData)
}

export default {
  id: 'select',
  name: 'select',
  type: 'action',
  moduleName: 'editor_module_select',
  dataSet: {
    mods: 'select',
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'select',
        value: {}
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'fullsize',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: {
      name: 'select',
      isRequired: true,
      label: langValue('list'),
      labelValue: defaultValue.list,
      itemDefault: defaultItem(),
      item: [
        defaultItem()
      ],
      labelFontSize: 'default',
      valueFontSize: 'default'
    },
    detail: null
  }
}
